import React, { useState } from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";

const pointsData = [
  {
    title: "Eliminate On-Premise Hardware",
    content:
      "Hosted PBX solutions replace traditional hardware systems with a cloud-based setup, eliminating the need for costly on-premise equipment. This ensures streamlined operations with reduced maintenance efforts and expenses.",
  },
  {
    title: "Flexible Communication Anytime, Anywhere",
    content:
      "With hosted PBX, your team can connect and communicate from any device, anywhere in the world. This flexibility enhances collaboration and ensures uninterrupted communication, even for remote teams.",
  },
  {
    title: "Scalable for Growing Businesses",
    content:
      "Hosted PBX solutions are designed to scale effortlessly with your business needs. Whether adding new users, expanding to new locations, or integrating advanced features, it adapts to your growth seamlessly.",
  },
  {
    title: "Unified Communication System",
    content:
      "Hosted PBX combines voice, video, messaging, and collaboration tools into a unified platform. This integration simplifies communication, enhances productivity, and ensures consistent performance across your organization.",
  },
];

const HostedPbxSolutions = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className=" flex flex-col items-center justify-center p-6">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-4 ">
        <div className="md:w-2/3 space-y-6 p-4">
          <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mt-10">
            Advanced Multi-Tenant IP PBX Solution
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            A hosted IP PBX system empowers businesses by delivering essential
            communication capabilities without the need for bulky, expensive
            hardware. This eliminates the need for extensive monitoring and
            reduces costs associated with on-site multi-tenant IP PBX systems.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            At Ayanshtech, we streamline the development of hosted multi-tenant
            IP PBX solutions, enabling seamless connectivity for users anytime,
            anywhere. This solution facilitates efficient collaboration and
            enhances communication. Furthermore, a multi-tenant IP PBX system
            simplifies connecting remote branches or delivering PBX services to
            multiple tenants. Designed for small businesses, the system includes
            advanced features such as video calling, call recording, speed
            dialing, click-to-call functionality, voicemail, and call
            forwarding, among others.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className="rounded-3xl">
        <div className="text-center  mt-5">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Multi-Tenant IP PBX
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our custom Hosted IP PBX solution breaks free from traditional line
            limitations, enhances accessibility, and significantly reduces
            operational expenses.
          </p>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Integrated Billing</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Call Return and Routing</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Phone Book</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Call Detail Records (CDRs)</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Multilingual Support</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Find Me / Follow Me</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Blind and Attended Transfer</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Audio Conference Room</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Hold and Retrieve</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Selective Acceptance</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Configurable Routing Rules</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Playback Extensions</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Call Park & Pickup</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Selective and Anonymous Rejection</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Group Call Pickup</p>
            </div>

            <div className="relative flex flex-col space-y-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="absolute top-0 left-0 w-10 h-10"
              />
              <p className="text-lg ml-16">Intercom Dialing</p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="text-center mb-10 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Hosted PBX Solutions Are Essential
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
            Transitioning to a cloud-based phone system can unlock significant
            cost savings, enhance data security, and provide seamless
            scalability for your business.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-7xl mx-auto mb-20">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                Seamless collaboration with simplified management
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon9.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">Equipped with advanced features</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon10.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">Highly scalable and secure solution</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">No need for complex hardware or wiring</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon13.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">Simple to manage and user-friendly</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon15.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">An affordable and cost-effective choice</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-6 sm:p-8 mb-10 sm:mb-12 rounded-3xl">
        {/* Title Section */}
        <h2 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
          Tailored Hosted PBX Solution for Enterprises
        </h2>
        <p className="text-center text-base sm:text-lg md:text-xl text-gray-700 mb-8">
          Enhance your business communication with our advanced hosted PBX
          solutions. Our tailored services provide seamless integration,
          scalable features, and reliable connectivity, ensuring efficient call
          management and reduced operational costs. Transform your contact
          center into a future-ready communication hub with minimal
          infrastructure and maximum flexibility.
        </p>

        {/* Navigation Bar */}
        <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
          {pointsData.map((point, index) => (
            <button
              key={index}
              className={`text-base sm:text-lg font-medium ${
                activeIndex === index
                  ? "text-blue-600 underline"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {point.title}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div className="text-center max-w-5xl mx-auto p-4 border-t border-gray-300">
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
            {pointsData[activeIndex].content}
          </p>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Multi-Tenant Hosted IP PBX Solution
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Unlock cost savings by moving your phone systems to the cloud. Our
          multi-tenant IP PBX solution offers enhanced data security and
          seamless scalability.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\pbx.png"
              alt="Best IP PBX Solution Provider in India"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Detailed reporting and dashboards to monitor performance and
                  enhance customer service.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  VoIP-ready features for seamless communication with reduced
                  lag and latency.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Multi-party conferencing for global collaboration from any
                  location.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  A cost-effective solution requiring minimal or no additional
                  hardware.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="text-center mb-12 mt-5 max-w-6xl">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Ayanshtech’s Multi-Tenant PBX Solution
          </h2>
          <p className="sm:text-base lg:text-lg mt-5 p-5">
            Ayanshtech’s hosted multi-tenant IP PBX solution is an outstanding
            choice to centralize and streamline your organization's
            communication network. Businesses with a global presence can benefit
            from our custom-designed multi-tenant IP PBX software, offering
            localized experiences for branch offices worldwide. Enhance team
            collaboration effortlessly while relying on a robust security
            framework to protect your digital infrastructure.
          </p>
        </div>
      </div>

      <GetInTouch />
    </div>
  );
};

export default HostedPbxSolutions;
